<template>
  <div class="flex justify-center min-h-screen px-4 sm:px-8 bg-neutral-950 font-averta">
    <RouterView/>
  </div>
</template>
